'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Chip } from '@lichtblick/photon/atoms/chip/chip';
import { Text } from '@lichtblick/photon/atoms/text/text';
import radioButtonStyles from '@lichtblick/photon/molecules/legacy-radio/radio-button.module.scss';
import { AccordionTrigger } from '@lichtblick/photon/organisms/accordion/accordion';
import { useTracker } from '@lichtblick/tracker';
import classNames from 'classnames';
import styles from './calculator-layout-trigger.module.scss';
export const CalculatorLayoutTrigger = ({ actionTriggerDisabled, chip, className, color, headline, icon })=>{
    const { trackCustomEvent } = useTracker();
    const Trigger = actionTriggerDisabled ? 'div' : AccordionTrigger;
    return /*#__PURE__*/ _jsxs(Trigger, {
        className: classNames(styles['accordion-trigger'], styles[`accordion-trigger-bg-${color}`], className),
        ...actionTriggerDisabled && {
            'data-state': 'open'
        },
        ...!actionTriggerDisabled && {
            onClick: ()=>trackCustomEvent({
                    eventName: 'tariff_calculator_interaction'
                }, undefined, true)
        },
        children: [
            !actionTriggerDisabled && /*#__PURE__*/ _jsx("span", {
                className: classNames(styles['radio-button'], radioButtonStyles['radio-button'], radioButtonStyles['state-default'])
            }),
            headline && /*#__PURE__*/ _jsx(Text, {
                bold: true,
                renderAs: "span",
                size: "l",
                children: headline
            }),
            Boolean(chip) && /*#__PURE__*/ _jsx(Chip, {
                backgroundColor: "White",
                className: styles.chip,
                children: chip
            }),
            icon
        ]
    });
};

//# sourceMappingURL=calculator-layout-trigger.js.map